module.exports = __webpack_public_path__ + "static/isolation_header-e3f37b394164ddfdf2b01c9a1ba1efc2.jpg";